










import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { UserLoginStats } from "../api";

interface Filters {
  onlyLoggedIn: boolean;
}

@Component
export default class UserFilter extends Vue {
  @Prop({ required: true })
  value!: UserLoginStats[];
  @Prop({ required: true })
  allUsers!: UserLoginStats[];

  filters: Filters = { onlyLoggedIn: true };

  @Watch("allUsers", { immediate: true })
  onAllUsers(): void {
    this.applyFilters(this.filters);
  }

  @Watch("filters", { deep: true })
  applyFilters(filters: Filters): void {
    let filtered = this.allUsers;

    if (filters.onlyLoggedIn) {
      filtered = filtered.filter((v) => v.times_logged_in > 0);
    }

    this.$emit("input", filtered);
  }
}
